import React from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { CraftMarquee } from './components/CraftMarquee';
import { WhatsInside } from './components/WhatsInside';
import { Mechanism } from './components/Mechanism';
import { FuturePaced } from './components/FuturePaced';
import { PurchaseSection } from './components/PurchaseSection';
import { Guarantee } from './components/Guarantee';
import { Bonuses } from './components/Bonuses';
import { Reviews } from './components/Reviews';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { StickyCta } from './components/StickyCta';
import { craftsAnimals, craftsMachines } from './data/crafts';
export function App() {
  return <div className="w-full overflow-x-hidden bg-paper font-sans text-ink" data-id="element-0" data-mp="2whxd1y9zzwht">
      <main data-id="element-1" data-mp="28suveqfd63nb">
        {/* 1 + 2 — Hero promise and large product visual */}
        <Hero data-id="element-2" data-mp="23u9ueosaffxt" />

        {/* 3 — Pain */}
        <PainSection data-id="element-3" data-mp="23t8gmcjw0fce" />

        {/* 4 — Auto-scrolling carousel #1 */}
        <section aria-label="Paper craft animals you can print and build" className="bg-paper pb-4 pt-14 sm:pt-20" data-id="element-4" data-mp="3ij61y35c994p">
          <p className="mb-6 px-5 text-center font-display text-[12px] font-extrabold uppercase tracking-[0.22em] text-brand" data-id="element-5" data-mp="3mjq3rk0ux0x6">
            A few of the 1,200+ projects
          </p>
          <CraftMarquee items={craftsAnimals} direction="left" speed={56} label="Animals and creatures included in the kit" data-id="element-6" data-mp="4n7u7q58zd7" />
        </section>

        {/* 5 — What's inside */}
        <WhatsInside data-id="element-7" data-mp="33oi0r16z0wuw" />

        {/* 6 — Mechanism */}
        <Mechanism data-id="element-8" data-mp="38l03xwmnkn54" />

        {/* 7 — Auto-scrolling carousel #2 */}
        <section aria-label="Paper craft vehicles, robots and worlds you can print and build" className="bg-paper pb-6 pt-2 sm:pb-10" data-id="element-9" data-mp="3dle1gkqmoeow">
          <p className="mb-6 px-5 text-center font-display text-[12px] font-extrabold uppercase tracking-[0.22em] text-brand" data-id="element-10" data-mp="nxn5hsc273nd">
            Something different to build almost every day
          </p>
          <CraftMarquee items={craftsMachines} direction="right" speed={56} label="Vehicles, robots and buildings included in the kit" data-id="element-11" data-mp="38kvshhq5xim" />
        </section>

        {/* 8 — Future-paced benefits */}
        <FuturePaced data-id="element-12" data-mp="86mev2f5hwu3" />

        {/* 9 + 10 — Purchase section with launch urgency and countdown */}
        <PurchaseSection data-id="element-13" data-mp="3gmfulf1nr4a3" />

        {/* 11 — Guarantee */}
        <Guarantee data-id="element-14" data-mp="3bmbf9schkflg" />

        {/* 12 — Bonuses */}
        <Bonuses data-id="element-15" data-mp="3bnmerfywf16r" />

        {/* 13 — Reviews */}
        <Reviews data-id="element-16" data-mp="3qb7jtffc3ahb" />

        {/* 14 — FAQ */}
        <Faq data-id="element-17" data-mp="3qbzgktko3e96" />

        {/* 15 — Final CTA */}
        <FinalCta data-id="element-18" data-mp="3lkheg26wr7mm" />
      </main>

      <footer className="border-t border-hairline bg-paper pb-[92px] pt-10 lg:pb-10" data-id="element-19" data-mp="3lk7lc5qkgkcp">
        <div className="mx-auto flex max-w-content flex-col items-center gap-2.5 px-5 text-center" data-id="element-20" data-mp="2xudaftpt55v3">
          <p className="font-display text-[13px] font-bold uppercase tracking-[0.22em] text-ink" data-id="element-21" data-mp="2swbuhhnohmnu">
            3D Paper Craft Mega Kit
          </p>
          <p className="text-[14px] text-muted" data-id="element-22" data-mp="18cgefssec1l4">
            100% digital product · Instant access · One-time payment
          </p>
        </div>
      </footer>

      <StickyCta data-id="element-23" data-mp="ygd43zne4wn3" />
    </div>;
}